import { handleActions } from 'redux-actions'
import * as type from './type'


export const initialState = {
    voucherCode: {
        value: '',
    },
    fetching: false,
    error: null,
    voucherTable: {
        objectList: [],
    }
}


export default handleActions({
    [type.CHANGE_VOUCHER_CODE]: (state, action) => {
        const { name, value } = action.payload
        return {
            ...state,
            voucherCode: {
                [name]: value,
            }
        }
    },
    [type.REQUEST_VOUCHER_TABLE_DATA]: (state, action) => {
        return {
            ...state,
            fetching: true,
        }
    },
    [type.CHANGE_VOUCHER_TABLE_DATA]: (state, action) => {
        const { objectList } = action.payload
        return {
            ...state,
            [type.VOUCHER_TABLE]: {
                ...state[type.VOUCHER_TABLE],
                objectList,
            },
            fetching: false,
        }
    },
    [type.ERROR_VOUCHER_TABLE_DATA]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            [type.VOUCHER_TABLE]: {
                ...state[type.VOUCHER_TABLE],
                'objectList': [],
            },
            fetching: false,
            error: error
        }
    },

}, initialState)


// WEBPACK FOOTER //
// ./src/modules/voucher/state/search/reducer.js